import "./Footer.css";

export default function Footer() {
    return (
        <footer>
            <div id="footer-topline" />

            <div id="footer-content">
                <h4>Mario Kart Custom Cup Builder</h4>
                <p>Found a bug? An inappropriate name? Or you have feedback? Contact me here:</p>
                <ul>
                    <li>Email: <a href="mailto:mk8dxcupbuilder@gmail.com">mk8dxcupbuilder@gmail.com</a></li>
                    <li><code>nexianworld</code> on Discord</li>
                    <li><a href="https://channel3.gg/ianr" rel="noopener" target='_noblank'>@ianr</a> on Channel 3</li>
                    <li><a href="https://twitter.com/nexianworld" rel="noopener" target='_noblank'>@NexianWorld</a> on Twitter</li>
                </ul>

                <p>
                    All Mario Kart licensed assets used (original or edited in
                    any way) belong to Nintendo and were sourced directly from Nintendo's official materials.
                    I am not using these assets for profit, just for fun.
                </p>

                <p>
                    The <a href="https://ko-fi.com/s/e7d9d18150"
                        rel="noopener"
                        target="_noblank"
                    >
                        "Racers Delight" font
                    </a> inspired by Mario Kart World was created
                    by <a href="https://twitter.com/ImWhoreHay"
                        rel="noopener"
                        target="_noblank"
                    >
                        @ImWhoreHay
                    </a> on X/Twitter.
                </p>
            </div>
        </footer>
    );
}
